import { render, staticRenderFns } from "./CollectTypeCmp.vue?vue&type=template&id=5e03111e"
import script from "./CollectTypeCmp.vue?vue&type=script&lang=js"
export * from "./CollectTypeCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e03111e')) {
      api.createRecord('5e03111e', component.options)
    } else {
      api.reload('5e03111e', component.options)
    }
    module.hot.accept("./CollectTypeCmp.vue?vue&type=template&id=5e03111e", function () {
      api.rerender('5e03111e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/quotationManagement/cmp/CollectTypeCmp.vue"
export default component.exports